import { useAppSelector } from '@/redux/hooks.ts'
import { selectUser } from '@/features/user/user.slice.ts'
import { RankTag } from '@/pages/overall-ranking/components/overall-ranking-card/rank-tag.tsx'

interface RankColumnProps {
  data: {
    rank: number | null
    rankTotal: number
    bookId?: string
    firmName?: string
  }
  groupByFirm?: boolean
}

// Rank shown as the shared rank/total pill (see RankTag), matching the mobile
// card view.
export const RankColumn: React.FC<RankColumnProps> = ({
  data,
  groupByFirm,
}) => {
  const user = useAppSelector(selectUser)
  // Only the caller's own row gets the primary brand border.
  const isSelf = groupByFirm
    ? !!user?.firmName && data.firmName === user.firmName
    : !!user?.bookId && data.bookId === user.bookId
  return <RankTag rank={data.rank} rankTotal={data.rankTotal} isSelf={isSelf} />
}
